module.exports = __webpack_public_path__ + "img/user.da58dc64.jpg";